import { render, staticRenderFns } from "./EmailComponent.vue?vue&type=template&id=7ad223cb&scoped=true&"
import script from "./EmailComponent.vue?vue&type=script&lang=js&"
export * from "./EmailComponent.vue?vue&type=script&lang=js&"
import style0 from "./EmailComponent.vue?vue&type=style&index=0&id=7ad223cb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad223cb",
  null
  
)

export default component.exports